import { createContext } from 'react'

import { XyoWorldMapStyle } from '../../lib'

export interface PlayMapSettings extends Record<string, boolean | undefined> {
  assay?: boolean
  geotokens?: boolean
  grid?: boolean
  quadkeys?: boolean
  tileVectors?: boolean
}

interface AppSettings {
  darkMode?: boolean
  developerMode?: boolean
  enableDarkMode?: (value: boolean) => void
  enableDeveloperMode?: (value: boolean) => void
  enableInfuraAsDefaultProvider?: (value: boolean) => void
  enableRequestLocation?: (value: boolean) => void
  infuraAsDefaultProvider?: boolean
  mapStyle?: XyoWorldMapStyle
  playMapSettings?: PlayMapSettings
  requestLocation?: boolean
  updateMapStyle?: (value: XyoWorldMapStyle) => void
  updatePlayMapSettings?: (value: PlayMapSettings) => void
}

export const AppSettingsContext = createContext<AppSettings>({})
